import VideoPlayer from 'components/shared/video/video';
import useIsMobile from 'hooks/utils/useIsMobile';
import classNames from 'classnames';
import styles from './videoPlayer.module.scss';

const VideoPlayerSection = ({ data }) => {
  const { video, autoplay, anchorId } = data;
  const isMobile = useIsMobile();
  const mediaType = video.type;
  let source;
  if (mediaType === 'Image') {
    source = isMobile ? video.image.mobile : video.image.desktop;
  } else {
    source = video.video;
  }

  return (
    <section id={anchorId}>
      {mediaType === 'Video' && source && (
        <VideoPlayer
          className={classNames(styles.media)}
          thumbnail={video.thumbnail}
          source={source}
          autoPlay={autoplay}
        />
      )}
    </section>
  );
};

export default VideoPlayerSection;
